import { render, staticRenderFns } from "./RiwayatMesinDanPeralatanPage.vue?vue&type=template&id=74f69c92"
import script from "./RiwayatMesinDanPeralatanPage.vue?vue&type=script&lang=js"
export * from "./RiwayatMesinDanPeralatanPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports